export const SHIPPING_PLANS = [
  { value: "standard", label: "Standard — $5 shipping" },
  { value: "jewelry", label: "Jewelry — $10 shipping" },
  { value: "heavy", label: "Heavy objects — $15 shipping" },
  { value: "rushed", label: "Rushed — $20 shipping" },
];

export const shippingLabel = (type) =>
  SHIPPING_PLANS.find((p) => p.value === type)?.label || type || "—";
